/**
 * Single Services Page Functionality
 * Handles show more/less functionality for service sections
 */

class SingleServices {
    constructor() {
        this.init();
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        const toggleButton = document.querySelector('.services-toggle__button');
        
        if (toggleButton) {
            toggleButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.toggleSections();
            });
        }
    }

    toggleSections() {
        const hiddenBoxes = document.querySelectorAll('.box--hidden');
        const showMoreText = document.querySelector('.show-more-text');
        const showLessText = document.querySelector('.show-less-text');
        
        if (hiddenBoxes.length === 0) return;
        
        const isExpanded = hiddenBoxes[0].classList.contains('box--show');
        
        hiddenBoxes.forEach(box => {
            if (isExpanded) {
                // Ukryj sekcje
                box.classList.remove('box--show');
            } else {
                // Pokaż sekcje
                box.classList.add('box--show');
            }
        });
        
        // Przełącz tekst przycisku
        if (isExpanded) {
            showMoreText.style.display = 'inline';
            showLessText.style.display = 'none';
        } else {
            showMoreText.style.display = 'none';
            showLessText.style.display = 'inline';
        }
    }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    if (document.body.classList.contains('single-services')) {
        new SingleServices();
    }
});
